function toFiniteNumber(value) {
    if (value === null || value === undefined || value === "") {
        return null;
    }
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
}
function firstFiniteNumber(...values) {
    for (const value of values) {
        const numericValue = toFiniteNumber(value);
        if (numericValue !== null)
            return numericValue;
    }
    return null;
}
function roundCurrency(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
}
export function getItineraryPdfPricing(item, locale) {
    const baseSubtotal = firstFiniteNumber(item.subtotal, item.total_price, item.base_price) ?? 0;
    const charges = normalizeCharges(item.charges, locale === "en" ? "Additional charges" : "Cargos adicionales");
    // Sum of the charge lines actually rendered, used to reconcile the rows.
    const renderedChargeTotal = roundCurrency(charges.reduce((total, charge) => total + charge.computedAmount, 0));
    const extraChargeTotal = firstFiniteNumber(item.extra_charge_total) ?? renderedChargeTotal;
    const explicitTaxAmount = firstFiniteNumber(item.tax_amount);
    const explicitTotal = firstFiniteNumber(item.total_amount, item.total);
    const taxAmount = explicitTaxAmount ??
        Math.max((explicitTotal ?? baseSubtotal) - baseSubtotal, 0);
    const derivedCustomerSubtotal = firstFiniteNumber(item.customer_subtotal) ??
        (explicitTotal !== null && explicitTaxAmount !== null
            ? roundCurrency(explicitTotal - explicitTaxAmount)
            : null);
    // The customer-facing "Subtotal" row folds in the concierge commission (it is
    // never rendered as its own line), so Subtotal + charge lines + taxes = Total.
    const serviceSubtotal = derivedCustomerSubtotal !== null
        ? roundCurrency(derivedCustomerSubtotal - renderedChargeTotal)
        : roundCurrency((firstFiniteNumber(item.service_subtotal) ?? baseSubtotal) +
            (firstFiniteNumber(item.commission_amount, item.commission_total_value) ?? 0));
    const customerSubtotal = derivedCustomerSubtotal ??
        roundCurrency(serviceSubtotal + renderedChargeTotal);
    const total = explicitTotal ?? customerSubtotal + taxAmount;
    const taxRate = firstFiniteNumber(item.tax_rate) ??
        (customerSubtotal > 0 ? taxAmount / customerSubtotal : 0);
    return {
        serviceSubtotal,
        extraChargeTotal,
        charges,
        subtotal: customerSubtotal,
        taxAmount,
        taxRate,
        total,
    };
}
function normalizeCharges(value, groupedLabel) {
    if (!Array.isArray(value))
        return [];
    const lines = value
        .map((charge) => {
        const record = charge;
        const displayMode = record.display_mode === 'GROUPED' || record.displayMode === 'GROUPED'
            ? 'GROUPED'
            : 'LINE_ITEM';
        return {
            name: String(record.name ?? ''),
            computedAmount: firstFiniteNumber(record.computed_amount, record.computedAmount) ?? 0,
            displayMode,
        };
    })
        .filter((charge) => charge.name.length > 0);
    const groupedTotal = roundCurrency(lines
        .filter((charge) => charge.displayMode === 'GROUPED')
        .reduce((total, charge) => total + charge.computedAmount, 0));
    return [
        ...lines.filter((charge) => charge.displayMode === 'LINE_ITEM'),
        ...(groupedTotal > 0
            ? [{ name: groupedLabel, computedAmount: groupedTotal, displayMode: 'GROUPED' }]
            : []),
    ];
}
